import GroupsView from '@/views/Groups/GroupsView.vue'
import { GROUP_ROLES } from '@/views/Groups/groupAccess'

export default [
  {
    path: '/merchants/:merchantID?/groups',
    meta: {
      require_roles: GROUP_ROLES
    },
    component: GroupsView,
    name: 'GroupList'
  }
]
